/************************************
MODULE: Storage Sizes Carousel
 WHAT IT DOES:   initiate slick slider for storage sizes carousel
*************************************/
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
      define(['jquery'], factory);
  }
  else if (typeof exports === 'object') {
      module.exports = factory(require('jquery'));
  }
  else {
      root.returnExports = factory(root.jQuery);
  }
}(this, function($) {

  function init() {
    var $storageSizesSliders = $('.js-storage-sizes-carousel').not('.js-inited');

    if (!$storageSizesSliders.length) {
      return;
    }

    $('.js-storage-sizes-carousel').addClass('js-inited');

    initSlides();
  }

  function initSlides() {
    var slick = require('slick');
    var $carousel = $('.js-storage-sizes-carousel').not('.slick-initialized');

    // ad GA to arrow buttons, copied from carousel wrapper
    $carousel.on('init', function() {
      var buttons = $carousel.find('.slick-arrow');
      buttons.attr('data-tracking-action', $carousel.attr('data-tracking-action'));
      buttons.attr('data-tracking-category', $carousel.attr('data-tracking-category'));
      buttons.attr('data-tracking-label', $carousel.attr('data-tracking-label'));
      buttons.addClass('js-tracked');
    });

    // init carousel
    $carousel.slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
    });
  }

  return {
      init: init
  };

}));


/*****************
 ** WEBPACK FOOTER
 ** ./js/app/modules/storage-sizes-carousel/app.storage-sizes-carousel.js
 ** module id = 76
 ** module chunks = 24
 **/